import { baseApi } from "../baseApi";

export const PariwarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // =============================================
    // GET PENDING USERS (status = 2)
    // =============================================
    // =============================================
    // GET PENDING USERS (status = 0) - with Filters
    // =============================================
    getPendingUsers: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/pariwar-pending`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Pariwar"],
    }),

    // =============================================
    // GET SUCCESS USERS (status = 1) - with Filters
    // =============================================
    getSuccessUsers: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/pariwar-success`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Pariwar"],
    }),

    // =============================================
    // GET REJECTED USERS (status = 2) - with Filters
    // =============================================
    getRejectedUsers: builder.query({
      query: ({ waad_id = "", role = "" } = {}) => {
        let url = `/pariwar-rejected`;
        const params = [];
        if (waad_id) params.push(`waad_id=${waad_id}`);
        if (role) params.push(`role=${role}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
      providesTags: ["Pariwar"],
    }),

    // =============================================
    // GET ALL USERS WITH PAGINATION & FILTERS
    // =============================================
    getAllUsers: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = ""
      } = {}) =>
        `/pariwar-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["Pariwar"],
    }),

    // =============================================
    // GET SINGLE USER BY ID
    // =============================================
    getUserById: builder.query({
      query: (id) => ({
        url: `/pariwar-view/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Pariwar", id }],
    }),

    // =============================================
    // UPDATE SINGLE USER STATUS
    // =============================================
    updateUserStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/pariwar-status/${id}`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: ["Pariwar"],
    }),

    // =============================================
    // BULK STATUS UPDATE
    // =============================================
    bulkUpdateStatus: builder.mutation({
      query: ({ userIds, status }) => ({
        url: `/pariwar-bulk-status`,
        method: "PUT",
        body: { userIds, status },
      }),
      invalidatesTags: ["Pariwar"],
    }),
    updateUserProfile: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/user-update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Pariwar", "Sadasya"],
    }),

  }),
});

// Export all hooks
export const {
  useGetPendingUsersQuery,
  useGetSuccessUsersQuery,
  useGetRejectedUsersQuery,
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserStatusMutation,
  useBulkUpdateStatusMutation,
  useUpdateUserProfileMutation
} = PariwarApi;